import React, { useState, useEffect } from "react";
import PerformanceChart from "./PerformanceChart";
import SelectComponent from "../../../../ReusableComponents/SelectComponent";
import Popup from "../../../../ReusableFunctions/Popup";
import { getBhuMeetPerformanceAPI } from "../apis";

const DSPsOnboarded = ({ labels, commonFilters }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [bhumeetPerformance, setBhumeetPerformance] = useState({});
  const [selectedAccountStatus, setSelectedAccountStatus] = useState({
    value: null,
    label: "All"
  })

  const getDSPsOnboardedPerformace = async () => {
    try {
      setIsLoading(true)
      const bhumeetPerformance = await getBhuMeetPerformanceAPI({ ...commonFilters, accountStatus: selectedAccountStatus.value, performanceType: "dsps" })
      setBhumeetPerformance(bhumeetPerformance);
      setIsLoading(false)
    } catch (e) {
      Popup.alert("ERROR", "Error while getting performace data.", "ERROR")
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (commonFilters) getDSPsOnboardedPerformace()
  }, [commonFilters, selectedAccountStatus]);


  const accountStatuses = [{
    value: null,
    label: "All"
  }, {
    value: true,
    label: "Active"
  }, {
    value: false,
    label: "Inactive"
  }]
  return (
    <PerformanceChart
      header={{
        title: "Drone Service Providers",
        // rightContent: 
        // <SelectComponent
        //   controlStyle={{ height: "30px", minHeight: "30px", background: "none", width: "150px", padding: "0px", border: "1px solid #ddd", boxShadow: "none", color: "hsl(0deg 0% 20% / 64%)", fontSize: "10px" }}
        //   isSearchable={true}
        //   menuStyles={{
        //     width: "150px"
        //   }}
        //   placeholder={"Select account status..."}
        //   menuPlacement={"bottom"}
        //   list={accountStatuses}
        //   value={selectedAccountStatus}
        //   optionStyle={{
        //     fontSize: "12px",
        //     height: "30px",
        //     minHeight: "30px"
        //   }}
        //   valueContainerStyle={{
        //     marginTop: "-2px"
        //   }}
        //   indicatorsContainerStyle={{
        //     marginTop: "-3px"
        //   }}
        //   onChange={(salesBy) => {
        //     setSelectedAccountStatus(salesBy)
        //   }}
        // />
      }}
      labels={labels}
      dataSetLabel="DSPs count"
      prevMonthData={bhumeetPerformance.prevMonthData || 0}
      performanceData={bhumeetPerformance.chartData || []}
      isLoading={isLoading} />
  );
};

export default DSPsOnboarded;
